import script from "./ProgramPrototypeDesignModalRequirements.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramPrototypeDesignModalRequirements.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramPrototypeDesignModalRequirements.vue?vue&type=style&index=0&id=59fe7db9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fe7db9"]])

export default __exports__